import { isiOS } from "@/utils/detect";
import { initEnv, biliBridge } from "@bilibili/js-bridge";
initEnv();

biliBridge.callNative({
  method: "global.import",
  data: {
    namespace: "realityinteraction"
  }
});

const call = <T>(method: string, params?: {}, callback?: (args?: T) => void) => {
  console.log(`------------${method}----------`);
  let data = params;
  if (typeof params === "function" && !callback) {
    callback = params as (args?: T) => void;
    data = {};
  }
  const obj = {
    method,
    data,
    callback
  };
  biliBridge.callNative(obj);
};

const ADJUST_VERSION = 62305100;

function adjustParams(k, v?) {
  return new Promise((resolve) => {
    // if (isiOS) {
    //   k = parseInt(k);
    //   if (v !== undefined) {
    //     v = parseInt(v);
    //   }
    // }
    // resolve({ k, v });
    biliBridge.callNative({
      method: "global.getContainerInfo",
      callback: (info) => {
        let { build } = info;
        build = +build;
        // TODO: 天剑版本号
        if (isiOS && build < ADJUST_VERSION) {
          k = parseInt(k);
          if (v !== undefined) {
            v = parseInt(v);
          }
        }
        resolve({ k, v });
      }
    });
  });
}

export enum Ability {
  BLE_ADV = 0,
  BLE_SCAN,
  GPS,
  LINEAR_ACC,
  GYROSCOPE
}

type DeviceSupportedAbilitiesCallbackArgs = {
  abilities: Ability[];
};

type DeviceSupportedAbilitiesCallback = (args?: DeviceSupportedAbilitiesCallbackArgs) => void;

function getDeviceSupportedAbilities(cb: DeviceSupportedAbilitiesCallback): void {
  call("realityinteraction.getDeviceSupportedAbilities", cb);
}

export enum Reason {
  DEVICE_NOT_SUPPORTED = 0, // Device hardware not supported
  DEVICE_NOT_READY, // Bluetooth / GPS is not enabled
  USER_DENIED, // User denied permission
  USER_DENIED_BEFORE // User denied permission before
}

type PermissionCallbackArgs = {
  state: boolean; // true: GRANTED
  ability: Ability;
  reason?: Reason;
};

type PermissionCallback = (args?: PermissionCallbackArgs) => void;
function checkPermission(abilities: Ability[], cb: PermissionCallback): void {
  call("realityinteraction.checkPermission", { abilities }, cb);
}
function requestPermission(abilities: Ability[], cb: PermissionCallback): void {
  call("realityinteraction.requestPermission", { abilities }, cb);
}

export function requestPermissionWithEventDetection(startEventDetection, abilities: Ability[], cb: PermissionCallback) {
  stopEventDetection();
  call("realityinteraction.requestPermission", { abilities }, (res: any) => {
    startEventDetection();
    cb(res);
  });
}

// ##### NEARBY JSB #####

export type ScanResult = {
  remoteMid: number;
  rssi: number;
};

type ScanCallbackArgs = {
  state: boolean; // true: scanning...
  result?: ScanResult;
};

type ScanCallback = (args?: ScanCallbackArgs) => void;

// tag(xxxx) to UUID: 0000xxxx-0000-1000-8000-00805f9b34fb
function startNearbyScan(tag: string | number, cb: ScanCallback): void {
  // TODO: ios传参处理
  adjustParams(tag).then((res: any) => {
    call("realityinteraction.startNearbyScan", { tag: res.k }, cb);
  });
}

function stopNearbyScan(): void {
  call("realityinteraction.stopNearbyScan");
}

type AdvCallbackArgs = {
  state: boolean; // true: advertising...
};

type AdvCallback = (args?: AdvCallbackArgs) => void;

// tag(xxxx) to UUID: 0000xxxx-0000-1000-8000-00805f9b34fb
function startNearbyAdv(tag: string, mid: number, cb: AdvCallback): void {
  // TODO: ios传参处理

  adjustParams(tag).then((res: any) => {
    call("realityinteraction.startNearbyAdv", { tag: res.k, mid }, cb);
  });
}

function stopNearbyAdv(): void {
  call("realityinteraction.stopNearbyAdv");
}

// ##### EVENT JSB #####
enum BiliEvent {
  CHEERS = 0
}

type EventDetectionCallbackArgs = {
  state: boolean; // true: detecting...
  event?: BiliEvent;
};

type EventDetectionCallback = (args: EventDetectionCallbackArgs) => void;

function startEventDetection(cb: EventDetectionCallback): void {
  call("realityinteraction.startEventDetection", cb);
}

function stopEventDetection(): void {
  call("realityinteraction.stopEventDetection");
}

// ##### STORAGE JSB #####

function setKV(key: string, value: string) {
  // TODO: ios传参处理
  adjustParams(key, value).then((res: any) => {
    call("realityinteraction.setValueWithKey", { key: res.k, value: res.v });
  });
}

type GetKVCallback = (res?: { saved: boolean; value?: string }) => void;

function getKV(key: string, cb: GetKVCallback) {
  // TODO: ios传参处理
  adjustParams(key).then((res: any) => {
    call("realityinteraction.getValueWithKey", { key: res.k }, cb);
  });
}

// ##### VIBRATOR JSB #####

// System Default vibrate
function vibrate(): void {
  call("realityinteraction.vibrate");
}

export {
  getDeviceSupportedAbilities,
  checkPermission,
  requestPermission,
  startNearbyScan,
  stopNearbyScan,
  startNearbyAdv,
  stopNearbyAdv,
  startEventDetection,
  stopEventDetection,
  vibrate,
  setKV,
  getKV
};
